module.exports = __webpack_public_path__ + "img/unhappy.aebd4c50.gif";